import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { Form, FormActions, FormInput } from '../../../components/form/index.js';
import { useUsersContext } from '../../../contexts/users.tsx';
import { ChangePasswordModel } from '../../../models/users/changePasswordModel.ts';

const validationSchema = Yup.object().shape({
    oldPassword: Yup.string()
        .required('Old Password is required'),
    newPassword: Yup.string()
        .required('Password is required')
        .notOneOf([Yup.ref('oldPassword')], 'New password must be different from old password'),
    confirmPassword: Yup.string()
        .required('Confirm Password is required')
        .oneOf([Yup.ref('newPassword')], 'Passwords must match'),
});

const ChangePasswordBody = () => {
    const { changePassword } = useUsersContext();
    const navigate = useNavigate();
    const [changePasswordModel, setChangePasswordModel] = useState<ChangePasswordModel>({} as ChangePasswordModel);
    const [errors, setErrors] = useState<Record<string, string>>({});

    const handleInputChange = (e: any) => {
        const { id, value } = e.target;
        setChangePasswordModel((prevData) => ({
            ...prevData,
            [id]: value, // Update the corresponding field in state
        }));

        validationSchema
            .validateAt(id, { ...changePasswordModel, [id]: value })
            .then(() => setErrors((prev) => ({ ...prev, [id]: '' })))
            .catch((err) => setErrors((prev) => ({ ...prev, [id]: err.message })));
    };

    const handleSubmit = () => {
        validationSchema
            .validate(changePasswordModel, { abortEarly: false })
            .then(() => {
                changePassword(changePasswordModel);
            })
            .catch((err) => {
                const validationErrors: Record<string, string> = {};
                err.inner.forEach((error: Yup.ValidationError) => {
                    if (error.path) validationErrors[error.path] = error.message;
                });
                setErrors(validationErrors);
            });
    };

    return (
        <Form>
            <FormInput entity={changePasswordModel} handleInputChange={handleInputChange} fieldName='oldPassword' label='Old password' type="password" errors={errors} />
            <FormInput entity={changePasswordModel} handleInputChange={handleInputChange} fieldName='newPassword' label='New password' type="password" errors={errors} />
            <FormInput entity={changePasswordModel} handleInputChange={handleInputChange} fieldName='confirmPassword' label='Confirm password' type="password" errors={errors} />
            <FormActions
                mainAction={handleSubmit}
                mainActionText="Save"
                showCancelButton
            />
        </Form>
    );
};

export default ChangePasswordBody;